/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBriefcaseLock = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M7 3h10v4h5v5h-2V9H4v10h9v2H2V7h5zm2 4h6V5H9z" />
        <path d="M19.5 16c.887 0 1.333.587 1.333 1v1h-2.666v-1c0-.413.446-1 1.333-1zm3.333 2v-1c0-1.796-1.642-3-3.333-3s-3.333 1.204-3.333 3v1H15v6h9v-6z" />
      </g>
    </g>
  </Icon>
);
export { SvgBriefcaseLock as BriefcaseLock };
